import { createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

export const setProduct = createAction<{
  field: FlattenKeys<ProductState>;
  value: any;
}>(actionTypes.SET_PRODUCT);

export const resetProduct = createAction<void>(actionTypes.RESET_PRODUCT);

const productActions = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      setProduct: <T extends FlattenKeys<ProductState>>(payload: {
        field: T;
        value: DeepType<ProductState, T>;
      }) => dispatch<void>(setProduct(payload)),
      resetProduct: () => dispatch<void>(resetProduct()),
    },
  );

export default productActions;
